import {Holiday} from "../../domains/models/holiday";
import {message} from "antd";
import {modelMapper} from "./action/holiday-actions";
import DataLoading from "../../common/loading-data";
import React, {useCallback, useEffect, useState} from "react";
import HolidayView from "./holiday.view";
import {IHolidayFormData} from "./types/holidays.types";
import dayjs from "dayjs";
import server from "../../server";
import "../../styles/component/holiday.scss";

const sortHolidays = (holidays: Holiday[]) => {
    return holidays.sort((a, b) => {
        const startA = dayjs(a.date);
        const startB = dayjs(b.date);

        if (startA.isBefore(startB)) {
            return -1;
        } else if (startA.isAfter(startB)) {
            return 1;
        } else {
            return 0;
        }
    });
};

const HolidayPage = () => {
    const [holidays, setHolidays] = useState<Holiday[]>([]);
    const [selectedDate, setSelectedDate] = useState(dayjs());
    const [loading, setLoading] = useState(true);
    const selectedYear = selectedDate.year();

    const fetchHolidays = useCallback(async (year: number) => {
        try {
            setLoading(true);
            const holidays: Holiday[] = await server.holiday.list(year);

            const formattedHolidays = sortHolidays(holidays);
            setHolidays(formattedHolidays);
        } catch (e) {
            console.log(e);
            message.error("Failed to fetch holidays");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchHolidays(selectedYear);
    }, [fetchHolidays, selectedYear]);

    const onSubmit = async (formValues: IHolidayFormData) => {
        const payload: Holiday = modelMapper(formValues);
        if (formValues.id) {
            await server.holiday.update(formValues.id, payload);
            message.success("Holiday updated successfully!")
        } else {
            await server.holiday.create(payload)
            message.success("Holiday created successfully!")
        }
        const holidayDate = dayjs(payload.date);
        if (holidayDate.year() !== selectedYear) {
            setSelectedDate(holidayDate);
            return;
        }
        await fetchHolidays(holidayDate.year());
    }

    const deleteHoliday = async (id: string) => {
        try {
            await server.holiday.delete(id);
            const updatedHolidays = holidays.filter((holiday: any) => holiday.id !== id);
            setHolidays(updatedHolidays);
        } catch (e) {
            console.log("View error", e);
            message.error("Failed to delete holiday");
        }
    };

    return (
        loading && holidays.length === 0 ? <DataLoading title="Company Holidays"/> :
            <HolidayView
                holidays={holidays}
                loading={loading}
                selectedDate={selectedDate}
                onSelectedDateChange={setSelectedDate}
                onSubmit={onSubmit}
                deleteHoliday={deleteHoliday}
            />
    )
}

export default HolidayPage;
